<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title>Lion</ion-title>
        <ion-buttons @click="close" slot="start" style="padding-left: 10px">
          <ion-icon
            icon="arrow-back-outline"
            size="large"
            color="medium"
          ></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen>
      <form class="contact-form">
        <ion-grid>
          <ion-row
            style="height: 100%;"
            class="ion-align-items-center ion-justify-content-center"
          >
            <ion-col align-self-center size-md="6" size-lg="4" size-xs="12">
              <div class="ion-text-center ion-text-color-withe">
                <h3>{{ title }}</h3>
              </div>
              <div class="ion-padding">
                <div class="ion-margin-bottom">
                  <ion-item v-if="product.name" class="product-info">
                    <ion-thumbnail @click="zoomImage(product.image)" slot="end">
                      <img v-lazy="product.image" />
                    </ion-thumbnail>
                    <ion-label>
                      <h3>{{ product.name }}</h3>
                      <p>
                        {{
                          `${mdmoto.descripcion} - ${mdmoto.marcamoto.data.descripcion}`
                        }}
                      </p>
                      <ion-text color="primary">{{
                        $filters.currencyFormat(product.price)
                      }}</ion-text>
                    </ion-label>
                  </ion-item>
                  <ion-item v-if="cart.length > 0" class="product-info">
                    <ion-thumbnail @click="zoomImage(product.image)" slot="end">
                      <i class="mdi mdi-cart-check mdi-36px"></i>
                    </ion-thumbnail>
                    <ion-label>
                      <h3>Total</h3>
                      <ion-text color="primary">{{
                        $filters.currencyFormat(cartTotalPrice)
                      }}</ion-text>
                    </ion-label>
                  </ion-item>
                  <ion-item :class="classInput">
                    <ion-label position="stacked">Nombre</ion-label>
                    <ion-input
                      type="text"
                      v-model="message.name"
                      placeholder="Ingrese su nombre"
                    ></ion-input>
                  </ion-item>
                  <ion-text
                    v-if="errors.name"
                    class="text-danger"
                    color="danger"
                    >{{ errors.name[0] }}</ion-text
                  >
                </div>
                <div class="ion-margin-bottom">
                  <ion-item :class="classInput">
                    <ion-label position="stacked">Email</ion-label>
                    <ion-input
                      type="email"
                      v-model="message.email"
                      placeholder="example@mail.com"
                    ></ion-input>
                  </ion-item>
                  <ion-text
                    v-if="errors.email"
                    class="text-danger"
                    color="danger"
                    >{{ errors.email[0] }}</ion-text
                  >
                </div>
                <div class="ion-margin-bottom">
                  <ion-item :class="classInput">
                    <ion-label position="stacked">Teléfono</ion-label>
                    <ion-input
                      type="number"
                      v-model="message.phone"
                      placeholder="Dejar mi número para ser contactado"
                    ></ion-input>
                  </ion-item>
                  <ion-text
                    v-if="errors.phone"
                    class="text-danger"
                    color="danger"
                    >{{ errors.phone[0] }}</ion-text
                  >
                </div>
                <div
                  v-if="cart.length == 0 && !product"
                  class="ion-margin-bottom"
                >
                  <div>
                    <ion-item :class="classInput">
                      <ion-label position="stacked">Asunto</ion-label>
                      <ion-input
                        type="text"
                        v-model="message.subject"
                        placeholder="cual es el asunto"
                      ></ion-input>
                    </ion-item>
                    <ion-text
                      v-if="errors.subject"
                      class="text-danger"
                      color="danger"
                      >{{ errors.subject[0] }}</ion-text
                    >
                  </div>
                </div>
                <ion-item :class="classInput">
                  <ion-label position="stacked">Mensaje</ion-label>
                  <ion-textarea
                    rows="6"
                    v-model="message.message"
                    placeholder="Ingrese el mensaje"
                  ></ion-textarea>
                </ion-item>
                <ion-text
                  v-if="errors.message"
                  class="text-danger"
                  color="danger"
                  >{{ errors.message[0] }}</ion-text
                >
              </div>
              <div class="ion-padding">
                <small
                  >Este sitio está protegido por reCAPTCHA y la
                  <a href="https://policies.google.com/privacy" target="_blank"
                    >Política de Privacidad</a
                  >
                  de Google y aplican
                  <a href="https://policies.google.com/terms" target="_blank"
                    >Terminos de Servicio</a
                  >.
                </small>
                <ion-text
                  v-if="errors.g_recaptcha_response"
                  class="text-danger"
                  color="danger"
                  >{{ errors.g_recaptcha_response[0] }}</ion-text
                >
              </div>
              <div class="ion-padding">
                <ion-button
                  color="medium"
                  :disabled="false"
                  size="default"
                  type="button"
                  expand="block"
                  @click="sendMessage"
                  >Enviar</ion-button
                >
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-content>
  </ion-page>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export default {
  ionViewDidEnter() {},
  ionViewDidLeave() {},
  ionViewWillEnter() {},
  ionViewWillLeave() {
    this.$store.dispatch('app/messageData', {})
  },
  components: {},
  data() {
    return {
      cart: [],
      product: {},
      title: 'Contactenos',
      mdmoto: null,
      message: {
        email: '',
        name: '',
        phone: '',
        subject: '',
        message: '',
        g_recaptcha_response: '',
        typefrm: 'message',
        cart: [],
        cartTotalPrice: 0
      },
      errors: {},
      image: '',
      slideOpts1: {
        zoom: {
          maxRatio: 1
        }
      },
      zm: null
    }
  },
  computed: {
    classInput() {
      return 'lionInputNormal'
    },
    itemsCart() {
      return this.$store.state.cart.items
    },
    cartTotalPrice() {
      return this.$store.getters['cart/cartTotalPrice']
    }
  },
  beforeUnmount() {},
  mounted() {
    this.openMessageForm()
  },
  created() {},
  methods: {
    async zoomImage(image) {
      this.$store.dispatch('app/keepPageState', true)
      this.$store.dispatch('app/imageToView', image)
      this.$router.push({ name: 'view-image' })
    },
    openMessageForm() {
      if (this.$store.state.app.messageData.product) {
        this.product = this.$store.state.app.messageData.product
        this.title = this.$store.state.app.messageData.title
        this.mdmoto = this.$store.state.app.messageData.mdmoto
      }
      if (this.$store.state.app.messageData.cart) {
        this.cart = this.$store.state.app.messageData.cart
        this.title = this.$store.state.app.messageData.title
        console.log(this.cart)
      }
    },
    close() {
      this.$router.go(-1)
    },
    sendMessage() {
      let url = 'app-mobile/send-contact-message'
      if (this.product.name || this.cart.length > 0) {
        url = 'app-mobile/send-order'
        this.message.typefrm = 'order'
        if (this.product.name) {
          this.message.cart.push(this.product)
          this.message.cartTotalPrice = this.product.price
        } else if (this.cart.length > 0) {
          this.message.cart = this.cart
          this.message.cartTotalPrice = this.cartTotalPrice
        } else {
          this.message.cart = []
        }
      }
      this.$emitter.emit('full-loader', { open: true })
      grecaptcha.ready(() => {
        try {
          grecaptcha
            .execute(this.$store.state.app.config.site.RECAPTCHA_SITEKEY, {
              action: 'message'
            })
            .then((token) => {
              this.message.g_recaptcha_response = token
              this.$http
                .post(url, this.message)
                .then((res) => {
                  if (
                    this.message.typefrm === 'order' &&
                    this.cart.length > 0
                  ) {
                    this.$store.dispatch('cart/checkout')
                  }
                  this.$emitter.emit('toast', {
                    message:
                      res.data.result ||
                      'Su solicitud se ha procesado de forma exitosa!!!',
                    color: 'success'
                  })
                  this.$emitter.emit('message-form')
                  this.$emitter.emit('full-loader', { open: false })
                })
                .catch((err) => {
                  this.$emitter.emit('full-loader', { open: false })
                  if (err.response) {
                    this.errors = err.response.data.errors
                  } else {
                    this.$emitter.emit('message-form')
                  }
                })
            })
        } catch (error) {
          this.$emitter.emit('toast', {
            message: error.message,
            color: 'danger'
          })
          this.$emitter.emit('full-loader', { open: false })
        }
      })
    }
  }
}
</script>
<style scoped>
.contact-form ion-item {
  --border-color: transparent;
}
.contact-form .product-info {
  --border-color: transparent;
  --background: transparent;
  --border-color: transparent;
}
</style>
